<template>
<!-- Start Banner 
    ============================================= -->
    <div
      class="banner-area btn-video shape-right top-pad-50 bg-gray text-combo"
    >
      <div class="item">
        <div class="box-table">
          <div class="box-cell">
            <div class="container">
              <div class="row">
                <div class="double-items">
                  <div class="col-lg-7 info">
                    <h2 class="wow fadeInDown" data-wow-duration="1s">
                      Teletrabajo
                    </h2>
                    <p class="wow fadeInUp" data-wow-duration="1.5s">
                      Maneja tu negocio desde las alturas. Lleva tu negocio
                      lejos, llévalo a la nube. Llévalo a Vapp.
                    </p>
                    <div class="button wow fadeInLeft" data-wow-duration="1.7s">
                      <a
                        class="btn-simple md light"
                        target="_blank"
                        href="landing_pages/2021_03/index.html"
                        ><i class="fas fa-angle-right"></i> Saber más</a
                      >

                      <a
                        href="#videos"
                        class="theme video-play-button inline item-center relative"
                      >
                        <i class="fa fa-play"></i>
                      </a>
                    </div>
                  </div>
                  <div
                    class="col-lg-5 thumb max-right wow fadeInDown"
                    data-wow-duration="1s"
                  >
                    <img class="shape-animated" src="assets/img/vapp/bn1.png" alt="Thumb" style="
                          max-width: 115%;
                          border-radius: 30% 30% 30% 30%;
                          background-image: linear-gradient(to top, lightgrey 0%, lightgrey 1%, #e0e0e0 26%, #efefef 48%, #d9d9d9 75%, #bcbcbc 100%);">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Banner -->

</template>


<script>
    export default {
        name: "BannerPrincipal",
        components: {},
        beforeMount() {},
    };
</script>